import { z } from 'zod'

import { FeedItemLinkType } from '../constants/feed'

export const feedDeeplinkSchema = z.object({
  type: z.nativeEnum(FeedItemLinkType),
  data: z.record(z.unknown()),
})

export const feedContentDisplaySchema = z.object({
  title: z.string(),
  shortTitle: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  subDescription: z.string().optional().nullable(),
  imageUrl: z.string().optional().nullable(),
})

export const feedContentItemSchema = z.object({
  display: feedContentDisplaySchema,
  link: feedDeeplinkSchema.optional(),
})

export const feedContentCreateArgsSchema = z.object({
  display: feedContentDisplaySchema,
  link: feedDeeplinkSchema.optional(),
})
